module.exports = __webpack_public_path__ + "img/satisfaction-title-xl.dc7c2b14.png";